/**
 * Upload Collector API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { Proximity } from './proximity';
import { Separation } from './separation';
import { CollarLog } from './collarLog';
import { TrapEvent } from './trapEvent';
import { Mortality } from './mortality';
import { VaginalImplant } from './vaginalImplant';
import { Activity } from './activity';
import { VirtualFence } from './virtualFence';
import { GSMQuality } from './gSMQuality';
import { MortalityImplant } from './mortalityImplant';
import { GPSPosition } from './gPSPosition';


export interface WildlifeMsgDTO { 
    rawMessageId?: number;
    dataUploadSource?: WildlifeMsgDTO.DataUploadSourceEnum;
    sqlStatement?: WildlifeMsgDTO.SqlStatementEnum;
    activities?: Array<Activity>;
    gsmQualities?: Array<GSMQuality>;
    gpsPositions?: Array<GPSPosition>;
    separations?: Array<Separation>;
    mortalities?: Array<Mortality>;
    mortalityImplants?: Array<MortalityImplant>;
    vaginalImplants?: Array<VaginalImplant>;
    proximities?: Array<Proximity>;
    virtualFences?: Array<VirtualFence>;
    trapEvents?: Array<TrapEvent>;
    collarLogs?: Array<CollarLog>;
}
export namespace WildlifeMsgDTO {
    export const DataUploadSourceEnum = {
        Provider: 'PROVIDER',
        Gdx: 'GDX',
        HttpUpload: 'HTTP_UPLOAD'
    } as const;
    export type DataUploadSourceEnum = typeof DataUploadSourceEnum[keyof typeof DataUploadSourceEnum];
    export const SqlStatementEnum = {
        Insert: 'INSERT',
        Update: 'UPDATE',
        Delete: 'DELETE'
    } as const;
    export type SqlStatementEnum = typeof SqlStatementEnum[keyof typeof SqlStatementEnum];
}


export type SqlStatementEnum = typeof WildlifeMsgDTO.SqlStatementEnum[keyof typeof WildlifeMsgDTO.SqlStatementEnum];
